// Composables
import { createVuetify, VuetifyOptions } from "vuetify";
import { vuetifyTranslations } from "@/application/plugins/i18n";
import { useApp } from "@/application/composables/app";
import { aliases, lucideIcons } from "@/application/plugins/icons";
import { VFileUpload } from "vuetify/labs/components";

// Styles
import "vuetify/styles";
import "@/styles/main.scss";

import "@fontsource/roboto/100.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";

const { getAppConfig } = useApp();

const baseConfig: VuetifyOptions = {
  locale: {
    locale: "nl",
    messages: vuetifyTranslations,
  },
  components: {
    VFileUpload,
  },
  icons: {
    defaultSet: "lucideIcons",
    sets: { lucideIcons },
    aliases,
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#32afbc",
          "on-primary": "#FFFFFF",

          accent: "#268191",
          "on-accent": "#FFFFFF",

          secondary: "#f0f9fa",
          "on-secondary": "#0F172A",

          "stepper-surface": "#d7f0f2",
          "on-stepper-surface": "#268191",

          "surface-1": "#f5fafa",
          emphasis: "#6B8387",
          "font-color": "#0F172A",
          border: "#C0D9DD",
          error: "#dc2626",
          success: "#16a34a",
          warning: "#F97316",

          "error-2": "#FEE2E2",
          "on-error-2": "#991B1B",
        },
      },
    },
  },
  defaults: {
    VBtn: {
      rounded: "pill",
      elevation: 0,
    },
    VCard: {
      rounded: "lg",
      elevation: 0,
    },
    VTextField: {
      rounded: "lg",
      height: 56,
      variant: "solo",
    },
    VSelect: {
      rounded: "lg",
      height: 56,
      variant: "solo",
    },
    VAutocomplete: {
      rounded: "lg",
      variant: "solo",
    },
    VTextarea: {
      rounded: "lg",
      rows: 2,
      variant: "solo",
    },
    VAlert: {
      rounded: "lg",
    },
    VList: {
      prependGap: "8px",
    },
  },
};

export default createVuetify(getAppConfig(baseConfig));
